import React from 'react';
import ButtonBase from '../../Buttons/ButtonBase';

const NoMembership = (props) => {
  return (
    <div
      style={{
        margin: '0 auto',
        width: 'fit-content',
        display: 'flex',
        flexFlow: 'column',
        height: 424,
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          color: '#10587f',
          marginBottom: 11,
          fontSize: 24,
          textAlign: 'center',
          fontWeight: 'bold',
        }}
      >
        {props.title}
      </p>
      <p style={{ color: '#484848', marginBottom: 37, fontSize: 16, textAlign: 'center' }}>
        {props.subtitle}
      </p>
      <div style={{width: 248, margin: '0 auto'}}>
        <ButtonBase
          variant="secondary"
          style={{ width: 248, height: 40, margin: '0 auto' }}
          direction={props.direction}
        >
          {props.button}
        </ButtonBase>
      </div>
    </div>
  );
};

export default NoMembership;
